import { useState } from 'react'
import { useCurrentWorkspace } from '../hooks/useWorkspace'
import { CreateWorkspaceForm } from './CreateWorkspaceForm'
import { Modal } from './Modal'

const NEW = '__new__'

export function WorkspaceSwitcher() {
  const { workspace, workspaces, select } = useCurrentWorkspace()
  const [creating, setCreating] = useState(false)
  if (!workspace) return null
  return (
    <>
      <select
        className="switcher"
        aria-label="Workspace"
        value={workspace.id}
        onChange={(event) => (event.target.value === NEW ? setCreating(true) : select(event.target.value))}
      >
        {workspaces.map((w) => (
          <option key={w.id} value={w.id}>{w.name}</option>
        ))}
        <option value={NEW}>+ New workspace…</option>
      </select>
      <Modal open={creating} title="New workspace" onClose={() => setCreating(false)}>
        <CreateWorkspaceForm onCreated={() => setCreating(false)} />
      </Modal>
    </>
  )
}
